// Annotation Portal React UI for Manage Super_Admin

import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AssignSamples from "./modals/AssignSamples";
import SamplesInfo from "layouts/admin/samples/modals/SamplesInfo";
import SamplesDataTable from "layouts/admin/samples/data/SamplesDataTable";
// font-awesome
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import { getSamples, getStateSampleCount } from "services/sampleService";

function ManageSuper_Admin() {
  const [Open_admin_Sample, setOpen_admin_Sample] = useState(false);
  const [OpenAssignTo, setOpenAssignTo] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sampleList, setSampleData] = useState([]);
  const [sampleCount, setSampleCount] = useState([]);
  const [filters, setFilters] = useState({});

  /* fetch samples to show in datatable */

  const state = "Maharashtra";

  const defaultFilters = {
    state: state,
    status: "",
    annotator: "",
    village: "",
    discrepancy: "",
    language: "",
    page: 1,
    limit: 100,
  };

  const fetchSamples = async (filters) => {
    const data = await getSamples(filters);
    setSampleData(data);
  };

  const fetchSampleCount = async () => {
    const data = await getStateSampleCount(state);
    console.log(data);
    setSampleCount(data);
  };

  /* useEffect hook call when component get mount */
  useEffect(() => {
    fetchSamples(defaultFilters);
    fetchSampleCount();
  }, []);

  const { columns, rows } = SamplesDataTable({
    samples: sampleList,
    selectedRows,
    setSelectedRows,
  });

  // Called when user clicks "Filter" button in SampleInfo
  const handleFilterSubmit = (newFilters) => {
    setFilters(newFilters);
    fetchSamples(newFilters);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SamplesInfo
              open={Open_admin_Sample}
              onClose={() => setOpen_admin_Sample(false)}
              onFilterSubmit={handleFilterSubmit}
              sampleCounts={sampleCount}
            />
            <MDBox>
              {/* {selectedRows.length > 0 && enabled} */}
              <MDBox
                display="flex"
                alignItems="center"
                justifyContent={{ xs: "center", md: "flex-start" }}
                sx={{ mt: 2 }}
              >
                <Tooltip
                  title={selectedRows.length === 0 ? "No Sample Selected." : ""}
                  placement="right"
                >
                  <span>
                    <MDButton
                      disabled={selectedRows.length === 0}
                      variant="outlined"
                      color="info"
                      size="medium"
                      onClick={() => setOpenAssignTo(true)}
                      sx={{
                        boxShadow: 4,
                        borderRadius: 2,
                        overflow: "hidden",
                        backgroundColor: "#f9fafe",
                        color: "blue",
                        border: "2px solid blue",
                        "&:hover": { border: "2px solid blue", color: "blue" },
                        cursor: selectedRows.length === 0 ? "not-allowed" : "pointer",
                        "&:disabled": {
                          cursor: "not-allowed",
                          PointerEvents: "auto",
                          border: "2px solid #1A73E8",
                          "&:hover": {
                            outline: "2px solid red",
                            outlineOffset: "2px",
                            borderRadius: "8px", // to make it circular-ish if needed
                          },
                        },
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} /> &nbsp;&nbsp;Assign To
                    </MDButton>
                  </span>
                </Tooltip>
              </MDBox>
              <MDBox pt={3} pb={3}>
                <Card
                  sx={{
                    boxShadow: 4,
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundColor: "#f9fafe",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  {/* <MDBox p={3} lineHeight={1}>
                    <MDTypography variant="h6" fontWeight="medium">
                      Sample List
                    </MDTypography>
                  </MDBox> */}
                  <MDBox>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15, 20, 25] }}
                      showTotalEntries={true}
                      canSearch={true}
                      pagination={{ variant: "gradient", color: "info" }}
                      noEndBorder={false}
                    />
                  </MDBox>
                </Card>
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modals */}
      <AssignSamples
        open={OpenAssignTo}
        onClose={() => setOpenAssignTo(false)}
        selectedIds={selectedRows}
      />
    </DashboardLayout>
  );
}

export default ManageSuper_Admin;
